<template>
  <BaseTableView
    :head="tableHead"
    list-view="mdAndUp"
    :class="$vuetify.breakpoint.mdAndUp ? 'table' : ''"
  >
    <tr v-for="(item, key) in extra" :key="key">
      <td>{{ item.name }}</td>
      <td>{{ $formatTime(item.hours) }}</td>
    </tr>
    <tr class="all fw700">
      <td>{{ localStorage.translations.pages.common.text['total'] }}</td>
      <td>{{ allTime }}</td>
    </tr>
  </BaseTableView>
</template>

<script>
export default {
  name: 'TimeControlShowEmployeeTableAllTime',
  props: ['extra', 'allTime'],
  computed: {
    tableHead() {
      return [
        { text: this.localStorage.translations.pages.statistic_employee.tables['dopolnitelnaya-rabota'] },
        { text: this.localStorage.translations.pages.statistic_employee.tables['chasy'] },
      ]
    },
  },
}
</script>


